import React from 'react';
import varLogo from '../assets/img/brand/vista-ar.svg';
import interreg from '../assets/img/interreg/FCE_ERDF.png';
import flag from '../assets/img/interreg/EUFlag.jpg';


function Footer(props) {
  return (
    <div
      className="App-footer d-flex flex-wrap align-items-center justify-content-center"
    >
      <img className="mx-2" src={varLogo} height="37px" width="152px" alt="VISTA AR logo" />
      <img className="mx-2" src={interreg} height="40px" width="93px" alt="Interreg logo" />
      <img className="mx-2" src={flag} height="40px" width="58px" alt="EU flag" />
    </div>
  );
}

export default Footer;
